import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { of } from "rxjs";
import { tap } from "rxjs/operators";
import { isNullOrUndefined } from "util";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var RoleService = /** @class */ (function () {
    function RoleService(httpClient) {
        this.httpClient = httpClient;
    }
    RoleService.prototype.getAgentHigherRole = function (currentUserName) {
        var _this = this;
        var shouldGetSavedRole = this.userName && (this.userName === currentUserName || isNullOrUndefined(currentUserName)) && this.agentHigherRole;
        if (shouldGetSavedRole) {
            return of(this.agentHigherRole);
        }
        else {
            this.userName = currentUserName;
            return this.httpClient.get(environment.server.api.portalpas + "/user/role").pipe(tap(function (role) {
                _this.agentHigherRole = role;
            }));
        }
    };
    RoleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleService_Factory() { return new RoleService(i0.ɵɵinject(i1.HttpClient)); }, token: RoleService, providedIn: "root" });
    return RoleService;
}());
export { RoleService };
